module.exports = __webpack_public_path__ + "static/media/podavane_signal_narushenie_1.d2cca25d.pdf";